import useAuthContext from '../context/authContext/useAuthContext';
import { useLocalStorage } from './useLocalStorage';

export const useUser = () => {
    const { user, setUser } = useAuthContext();
    const { setItem, removeItem } = useLocalStorage();

    const addUser = (user) => {
        setUser(user);
        setItem('@UPASSAEVENE_USER', JSON.stringify(user));
    };

    const removeUser = () => {
        setUser(null);
        removeItem('@UPASSAEVENE_USER');
    };

    return { user, addUser, removeUser };
};
